import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaLengthFacet extends XmlSchemaFacet {}
